import React from 'react';
import bugsnag from 'bugsnag-js';
import createPlugin from 'bugsnag-react';

const { version } = require('../../package.json');

const bugsnagClient = bugsnag({
  apiKey: 'd5d79849723530c16b364642b4a74e34',
  appVersion: version,
  notifyReleaseStages: ['production']
});
const ErrorBoundry = bugsnagClient.use(createPlugin(React));

export { bugsnagClient, ErrorBoundry };



// WEBPACK FOOTER //
// ./src/logger/bugsnag.js